import React from 'react'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import './OnboardingTrackerPage.css'

const OnboardingTrackerPageUI = ({
    context,
    account,
    events = [],
    loading,
    error,
    onRefreshClick,
    expandedRowId,
    onExpandRow,
    dropdownData,
    dropdownLoading,
    dropdownError
}) => (
    <SuperUserAccountPageUI
        context={context}
        className='pg_su_acc'
        backLink='/su/accounts'
        headerText={`${account ? account.accountName : ''}`}
        dimension='w768'
        centered={!account}
        account={account}
        page='onboardingTracker'
    >
        {!account && loading && <SpinnerComponentUI />}

        {error && (
            <div className="g_error g_m_top_30">{error}</div>
        )}

        {account && (
            <div>
                <div className="onboarding-tracker-header">
                    <h2 className="onboarding-tracker-title">Onboarding Tracker</h2>
                </div>

                {loading ? (
                    <div className="g_center g_m_top_30">
                        <SpinnerComponentUI />
                    </div>
                ) : events.length === 0 ? (
                    <div className="g_center g_m_top_30">
                        <p className="g_muted_event">No events found for this account.</p>
                    </div>
                ) : (
                    <div className="onboarding-tracker-list">
                        {events.map((event) => (
                            <TrackerCard
                                key={event.sessionId}
                                event={event}
                                isExpanded={expandedRowId === event.sessionId}
                                onExpand={() => onExpandRow(event)}
                                dropdownData={dropdownData}
                                dropdownLoading={dropdownLoading}
                                dropdownError={dropdownError}
                            />
                        ))}
                    </div>
                )}
            </div>
        )}
    </SuperUserAccountPageUI>
)

const TrackerCard = ({ event, isExpanded, onExpand, dropdownData, dropdownLoading, dropdownError }) => {
    const getFormattedDate = (timestamp) => {
        if (!timestamp) return '-';
        const date = new Date(timestamp);
        // Format: 17-06-2025 19:22 PM
        // return date.toLocaleString(); 
        // Matching screenshot format roughly
        return `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
    };

    return (
        <div className="tracker-card">
            <div className="tracker-card-header" onClick={onExpand}>
                <div className="tracker-title-section">
                    <h4 className="tracker-event-code">{event.eventCode}</h4>
                    <p className="tracker-delivery-channel">Delivery channel: {event.deliveryChannel}</p>
                </div>

                <div className="tracker-info-grid">
                    <div className="info-item">
                        <span className="info-label">Status</span>
                        <span className="info-value">{event.status}</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Created</span>
                        <span className="info-value">{getFormattedDate(event.dateCreated)}</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Type</span>
                        <span className="info-value">{event.type}</span>
                    </div>
                </div>

                <div className={`tracker-expand-icon ${isExpanded ? 'expanded' : ''}`}>
                    <p>&#129051;</p>
                </div>
            </div>

            {isExpanded && (
                <div className="tracker-card-body">
                    {dropdownLoading ? (
                        <div className="g_center"><SpinnerComponentUI size="small" /></div>
                    ) : dropdownError ? (
                        <div className="text-danger">{dropdownError}</div>
                    ) : !dropdownData.length ?
                        (
                            <div className="g_center g_m_top_30">
                                <p className="g_muted_event">No details found for this event.</p>
                            </div>
                        ) : (
                            <table className="dropdown-table">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Number/Email</th>
                                        <th>Status</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dropdownData.length > 0 ? dropdownData.map((item, idx) => (
                                        <tr key={idx}>
                                            <td>{item.name}</td>
                                            <td>{item.phoneNumber || item.email || item.receivedAt}</td>
                                            <td>
                                                <span className={`status-badge ${item.status ? item.status.toLowerCase() : ''}`}>
                                                    {item.status}
                                                </span>
                                            </td>
                                            <td>{item.date ? new Date(item.date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : '-'}</td>
                                        </tr>
                                    )) : (
                                        <tr><td colSpan="2" className="text-center">No details found</td></tr>
                                    )}
                                </tbody>
                            </table>
                        )}
                </div>
            )}
        </div>
    )
}

export default OnboardingTrackerPageUI
